define('DatePicker.FromToday', [
    'Backbone.View.Plugin.DatePicker.FromToday'
],
function DatePickerFromToday(
    BackboneViewPluginDatePickerFromToday
) {
    'use strict';

    return  {
        mountToApp: function mountToApp(application) {
            BackboneViewPluginDatePickerFromToday.mountToApp(application);
        }
    };
});

